import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  historyPopup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 20,
    '& .popup__box': {
      maxWidth: 720,
      width: '100%'
    }
  },

  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },

  historyCard: {
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },

  historyRowHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8
  },

  historyRowContent: {
    display: 'flex',
    justifyContent: 'flex-start'
  },

  historyAnimalName: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.primary
  },

  historyDate: {
    fontSize: theme.app.typography.small.fontSize,
    color: theme.app.colors.text.secondary
  },

  loadingContainer: {
    position: 'relative',
    minHeight: '200px',
    width: '100%'
  },

  reproductionBadge: {
    borderRadius: theme.app.borderRadius.full,
    padding: '4px 10px',
    fontSize: theme.app.typography.small.fontSize,
    fontWeight: 500,
    color: theme.palette.primary.main,
    backgroundColor: 'rgba(103, 53, 53, 0.12)'
  },

  diagnosisBadge: {
    borderRadius: theme.app.borderRadius.full,
    padding: '4px 10px',
    fontSize: theme.app.typography.small.fontSize,
    fontWeight: 500
  },

  pendingBadge: {
    backgroundColor: '#F2C94C',
    color: theme.app.colors.text.primary
  }
}))
